import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import { toast } from 'react-toastify'
import AppliedList from '../../components/Leave/AppliedList'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_applied_leaves } from '../../actions/v3/leave'
import constant from '../../constant'
import moment from 'moment';
import ExportColumnModal from '../../components/common/ExportColumnModal';
import RecordListFilters from '../../components/common/RecordListFilters';
import { exportRowsToExcel, getLoggedInUserRoleId, replacePageState } from '../../utils';
import { hasPermission } from '../../utils/hasPermission';
import { v3_delete_leave_application } from '../../actions/v3/leave';
const List = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)
    const [filters, setFilters] = useState({ fromDate: '', toDate: '', name: '', subject: '' });
    const [isExporting, setIsExporting] = useState(false);
    const isAdmin = Number(getLoggedInUserRoleId()) === 1;
    const canEditLeaveApplications = isAdmin || hasPermission(constant.actionPermission.leaveEditApplication);
    const exportColumns = [
        { key: 'name', label: 'Employee Name', value: item => item.EMPLOYEE_NAME || item.FULL_NAME },
        { key: 'location', label: 'Location', value: item => item.LOCATION_NAME },
        { key: 'leaveType', label: 'Leave Type', value: item => item.LEAVE_TYPE_NAME },
        { key: 'fromDate', label: 'From Date', value: item => item.LEAVE_FROM },
        { key: 'toDate', label: 'To Date', value: item => item.LEAVE_TO },
        { key: 'days', label: 'Total Days', value: item => item.TOTAL_DAYS },
        { key: 'subject', label: 'Subject / Note', value: item => item.NOTE },
        { key: 'status', label: 'Status', value: item => item.STATUS },
        { key: 'remarks', label: 'Remarks', value: item => item.REMARKS },
    ];

    useEffect(() => {
        v3_applied_leaves(currentPage, limit, filters).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.leaveApplied.url, {
                    page: currentPage // Replace 'yourData' with the data you want to pass
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit, filters])

    const updateFilters = (nextFilters) => {
        setCurrentPage(1);
        setFilters(nextFilters);
    };

    const exportLeaves = async (selectedColumns = exportColumns) => {
        try {
            setIsExporting(true);
            const rows = [];
            let exportPage = 1;
            while (true) {
                const res = await v3_applied_leaves(exportPage, 200, filters);
                if (!res?.status) throw new Error(res?.error || 'Unable to export leave applications.');
                const pageRows = res.result?.leaves || [];
                rows.push(...pageRows);
                if (pageRows.length < 200) break;
                exportPage += 1;
            }
            if (!rows.length) return toast.warn('No leave applications to export.');
            exportRowsToExcel({ rows, columns: selectedColumns, sheetName: 'Leave Applications', fileName: `Leave_Applications_${moment().format('YYYYMMDD_HHmmss')}.xlsx` });
        } catch (error) {
            toast.error(error?.message || 'Unable to export leave applications.');
        } finally {
            setIsExporting(false);
        }
    };

    const deleteLeave = async (leaveId) => {
        if (!window.confirm('Delete this leave application? This cannot be undone.')) return;
        const res = await v3_delete_leave_application(leaveId);
        if (res.status) {
            toast.success(res.result?.message || 'Leave application deleted.');
            setCurrentPage(1);
            setFilters({ ...filters });
        } else toast.error(res.error || 'Unable to delete leave application.');
    };

    return (
        <Layout
            title={'Applied Leaves'}
        >
            <RecordListFilters value={filters} onChange={updateFilters} showName={false} subjectLabel="Leave type / note" />
            <div className="d-flex justify-content-end mb-3">
                <button className="btn btn-sm btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#applied-leave-export-columns-modal" disabled={isExporting}>
                    <i className={`mdi ${isExporting ? 'mdi-loading mdi-spin' : 'mdi-file-excel-outline'} label-icon`} /> {isExporting ? 'Exporting...' : 'Export'}
                </button>
            </div>
            {data && <AppliedList
                limit={limit}
                data={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                isAdmin={isAdmin}
                canEditApplications={canEditLeaveApplications}
                onDelete={deleteLeave}
            />}
            <ExportColumnModal modalId="applied-leave-export-columns-modal" title="Select Leave Columns" columns={exportColumns} onExport={exportLeaves} isExporting={isExporting} />
        </Layout>
    )
}

export default List
